import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { motion, useInView } from "framer-motion";

const GALLERY_IMAGES = [
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/rb1n0zvx_IMG_0412.jpeg",
    alt: "La salle du restaurant et son bar en bois",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/9q1vz2l5_IMG_0407.jpeg",
    alt: "Déjeuner en terrasse, verre de rosé",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/zw5anfx9_IMG_0411.jpeg",
    alt: "La carte du bistro et son bouquet provençal",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/al2orlmy_IMG_0408.jpeg",
    alt: "Façade du restaurant L'Ancienne Poste",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/e4jwa73m_IMG_0413.jpeg",
    alt: "La salle et ses fauteuils rouges",
    span: "md:col-span-2",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/0xqjcjqp_IMG_0404.jpeg",
    alt: "La grande salle du restaurant, vue d'ensemble",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/m765izx1_IMG_0403.jpeg",
    alt: "Tartare et son jaune d'œuf, création du chef",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/bnz9l3j1_IMG_0406.jpeg",
    alt: "Détail des fauteuils rouges et de la cheminée",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/p4tyzbr7_IMG_0405.jpeg",
    alt: "Vue sur le Mont Ventoux depuis la terrasse",
    span: "md:col-span-2",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/rllyzhyr_IMG_0410.jpeg",
    alt: "La façade et l'enseigne de L'Ancienne Poste",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/qg7r3i5s_IMG_0400.jpeg",
    alt: "La véranda du restaurant et sa cheminée",
    span: "md:col-span-2",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/p25o7bix_IMG_0399.jpeg",
    alt: "Crème catalane flambée",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/2suf0edd_IMG_0402.jpeg",
    alt: "Les doseurs du bar et les spiritueux",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/mtmevziw_IMG_0401.jpeg",
    alt: "Crème catalane caramélisée au chalumeau",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/vtutt7uv_IMG_0398.jpeg",
    alt: "Le bar en bois et ses tabourets",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/idcrmdsf_IMG_0397.jpeg",
    alt: "La terrasse ombragée sous la pergola et les guirlandes",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/tkchpd6h_IMG_0393.jpeg",
    alt: "Table pour deux sous le platane",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/l1tn7wbb_IMG_0396.jpeg",
    alt: "Bouquet de lavande sur une table de la terrasse",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/u3fm6s3a_IMG_0395.jpeg",
    alt: "Le patio sous la pergola orange",
    span: "md:col-span-2",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/hrp41twy_IMG_0394.jpeg",
    alt: "La grande terrasse du restaurant",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/unnwhdmt_IMG_0389.jpeg",
    alt: "La carte du bistro glissée dans la boîte aux lettres d'époque",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/1ea5p2qu_IMG_0390.jpeg",
    alt: "Bouquet provençal et verres sur une table dressée",
    span: "md:col-span-2",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/guuxokab_IMG_0388.jpeg",
    alt: "La carte de L'Ancienne Poste sur une table de la terrasse",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/avn9mgch_IMG_0392.jpeg",
    alt: "Table ronde sous la pergola de la terrasse",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/aiettly3_IMG_0391.jpeg",
    alt: "Papillon en céramique sur les claustras de la terrasse",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/rwysko0y_IMG_0383.jpeg",
    alt: "Tartare de saumon en feuille croustillante, jaune d'œuf et ciboulette",
    span: "md:col-span-2",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/qloxmsky_IMG_0382.jpeg",
    alt: "Tartare de saumon, panier de pain et verre de rosé en terrasse",
    span: "",
  },
  {
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_poste-entrechaux/artifacts/fngvqyte_IMG_0427.jpeg",
    alt: "Christelle et Clément, vos hôtes à L'Ancienne Poste",
    span: "md:col-span-2",
  },
];

export const GallerySection = () => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="galerie"
      data-testid="gallery-section"
      className="py-24 md:py-36 px-6 md:px-12 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto" ref={ref}>
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <p
            className="text-sm uppercase tracking-[0.3em] text-[#C1624D] mb-4"
            style={{ fontFamily: "'Lato', sans-serif" }}
          >
            {t("gallery.label")}
          </p>
          <h2
            className="text-4xl md:text-5xl font-light tracking-tight text-[#2C2420]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
            data-testid="gallery-heading"
          >
            {t("gallery.heading")}
          </h2>
        </motion.div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 auto-rows-[260px]">
          {GALLERY_IMAGES.map((img, i) => (
            <motion.div
              key={img.url}
              initial={{ opacity: 0, y: 24 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className={`gallery-item relative overflow-hidden rounded-sm cursor-pointer ${img.span}`}
              data-testid={`gallery-image-${i}`}
            >
              <img
                src={img.url}
                alt={img.alt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 hover:bg-black/20 transition-colors duration-400" />
            </motion.div>
          ))}
        </div>

        {/* Photographer credit */}
        <p
          className="mt-6 text-xs text-[#8C847F] text-center tracking-wide"
          style={{ fontFamily: "'Lato', sans-serif" }}
          data-testid="photo-credit"
        >
          © Photos : Christophe Abbes
        </p>
      </div>
    </section>
  );
};
